export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/5 bg-[#16191F] px-6 md:px-12 py-14"
    >
      <div className="max-w-7xl mx-auto flex flex-col items-center text-center gap-6">
        <div>
          <p className="font-logo text-4xl font-bold tracking-tight inline-flex items-start justify-center">
            <span>Raahi</span>
            <span className="text-[#D9544E]">.</span>
            <span className="ml-1 mt-1 align-top text-[0.7rem] font-sans font-medium leading-none text-[#F4F1ED]/50">™</span>
          </p>
          <p className="mt-2 font-logo text-2xl font-bold text-[#F4F1ED]/80">Aapki bike ki sawaari</p>
        </div>

        <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm font-medium text-[#F4F1ED]/70">
          <a href="#" data-testid="footer-privacy" className="hover:text-[#E7B459] transition-colors">
            Privacy Policy
          </a>
          <a href="#" data-testid="footer-terms" className="hover:text-[#E7B459] transition-colors">
            Terms
          </a>
          <a href="mailto:hello@raahi.app" data-testid="footer-contact" className="hover:text-[#E7B459] transition-colors">
            Contact
          </a>
        </nav>

        <p className="max-w-2xl text-xs leading-relaxed text-[#F4F1ED]/40">
          Raahi™ is a trademark of Raahi Technologies Pvt. Ltd. All product
          names, logos and brands are the property of the respective entity.
        </p>

        <p className="max-w-2xl text-xs leading-relaxed text-[#F4F1ED]/40">
          © {year} Raahi. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
